import { useState }    from 'react';
import { HubConnection, HubConnectionState } from '@microsoft/signalr';
import { createModel } from 'hox';
import { IPlanGroupCompletionNotice, MessageType } from './types';

const useSignalrResolve = () => {
  const [isRetry, setIsRetry]               = useState<boolean>(false);
  const [isSignalrError, setIsSignalrError] = useState<boolean>(false);
  const [message, setMessage] = useState<MessageType | null>(null);
  const [planGroupNotice, setPlanGroupNotice] = useState<IPlanGroupCompletionNotice | null>(null);
  // 保存 HubConnection 实例，供业务侧主动探测 / invoke 使用
  const [hubConnection, setHubConnection] = useState<HubConnection | null>(null);
  // 实时连接状态：Connected / Reconnecting / Disconnected ...
  const [connectionState, setConnectionState] = useState<HubConnectionState>(HubConnectionState.Disconnected);

  // 连接状态变化时打印，用于排查连接是否正常
  // useEffect(() => {
  //   console.log(`[SignalR] connectionState: ${connectionState}`);
  // }, [connectionState]);
  return {
    isRetry,
    setIsRetry,
    isSignalrError,
    setIsSignalrError,
    message,
    setMessage,
    planGroupNotice,
    setPlanGroupNotice,
    hubConnection,
    setHubConnection,
    connectionState,
    setConnectionState,
  };
};

export const useSignalr = createModel(useSignalrResolve);
